export default {
  information: 'News',
  latestExhibition: 'Latest Exhibitions',
  latestNews: 'Latest News',
  notMultiple: 'Multiple Selection Not Supported',
  source: 'Source',
  category: 'Category',
  unfollowAction: 'Unfollow',
  followAction: 'Follow',
  unlikeAction: 'Unlike',
  likeAction: 'Like',
  shareAction: 'Share',
  relatedTags: 'Related Tags',
  copyrightStatement:
    'Copyright Statement: Some images/texts in articles are copyrighted by original authors. Not for commercial use. Contact us for removal if infringed.',
  industryExhibitions: 'Industry Exhibitions',
  relatedNews: 'Related News',
  industryNews: 'Industry News',
  wechatScanPrompt: 'Scan QR Code with WeChat to Follow'
}
